<template>
  <div class="st-seg" :class="[`st-seg--${size}`, { 'st-seg--on-shell': onShell }]" role="tablist">
    <button
      v-for="opt in options"
      :key="String(opt.value)"
      class="st-seg__item"
      :class="{ 'is-active': opt.value === model }"
      type="button"
      role="tab"
      :aria-selected="opt.value === model"
      @click="model = opt.value"
    >
      <font-awesome-icon v-if="opt.icon" :icon="['fas', opt.icon]" class="st-seg__icon" />
      <span v-if="opt.label">{{ opt.label }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
export interface SegmentOption {
  value: string | number;
  label?: string;
  icon?: string;
}

const model = defineModel<string | number>();
withDefaults(
  defineProps<{
    options: SegmentOption[];
    size?: 'sm' | 'md';
    onShell?: boolean;
  }>(),
  { size: 'md' },
);
</script>

<style scoped>
.st-seg {
  display: inline-flex;
  padding: 3px;
  gap: 2px;
  background: var(--st-surface-sunken);
  border: 1px solid var(--st-border);
  border-radius: var(--st-radius-md);
}
.st-seg__item {
  display: inline-flex;
  align-items: center;
  gap: var(--st-space-2);
  height: calc(var(--st-control-h-md) - 6px);
  padding: 0 var(--st-space-3);
  border: none;
  border-radius: var(--st-radius-sm);
  background: transparent;
  color: var(--st-text-muted);
  font-size: var(--st-text-sm);
  font-weight: var(--st-weight-medium);
  cursor: pointer;
  transition: var(--st-transition);
}
.st-seg--sm .st-seg__item {
  height: calc(var(--st-control-h-sm) - 6px);
  font-size: var(--st-text-xs);
}
.st-seg__item:hover:not(.is-active) {
  color: var(--st-text);
}
.st-seg__item.is-active {
  background: var(--st-surface);
  color: var(--st-text);
  box-shadow: var(--st-shadow-1);
}
.st-seg__icon {
  font-size: 0.9em;
}

/* ---- on the dark shell ---- */
.st-seg--on-shell {
  background: var(--st-shell-bg);
  border-color: var(--st-shell-border);
}
.st-seg--on-shell .st-seg__item {
  color: var(--st-shell-text-muted);
}
.st-seg--on-shell .st-seg__item:hover:not(.is-active) {
  color: var(--st-shell-text);
}
.st-seg--on-shell .st-seg__item.is-active {
  background: var(--st-shell-surface);
  color: var(--st-shell-text);
}
</style>
